import React from 'react';
import { SearchableSelect } from './SearchableSelect';
import { CURRENCIES } from '../../types';

interface CurrencySelectProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
}

export const CurrencySelect: React.FC<CurrencySelectProps> = ({
    value,
    onChange,
    placeholder = 'Select currency',
    disabled = false
}) => {
    const options = CURRENCIES.map(currency => ({
        value: currency.value,
        label: currency.label
    }));

    return (
        <SearchableSelect
            options={options}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
        />
    );
};
